// extracted by mini-css-extract-plugin
module.exports = {"logo":"header-module--logo--dkMqu","header":"header-module--header--3A712","title":"header-module--title--33kOg","subHeaderTitle":"header-module--subHeaderTitle--1ZjPZ"};